export default __webpack_public_path__ + "static/220803_天下布魔更新內容預告_chs-6a9bd98c31e4b6eaa265239ba2e629e2.png";